import { createSvgIcon, createMuiSvgIcon } from './utils';

import { ReactComponent as SlackSvg } from '../../assets/svg-icons/slack.svg';
import { ReactComponent as GoogleClassroomSvg } from '../../assets/svg-icons/google-classroom.svg';

// slack
export const CSlack = createSvgIcon(SlackSvg);
export const Slack = createMuiSvgIcon(SlackSvg, 'Slack');

// google classroom
export const CGoogleClassroom = createSvgIcon(GoogleClassroomSvg);
export const GoogleClassroom = createMuiSvgIcon(GoogleClassroomSvg, 'GoogleClassroom');